import React, { useContext, useEffect, useState } from 'react'
import {
  GameLogExt,
  PlayerProfileContext,
} from '../../../../Context/PlayerProfileContext/PlayerProfileContext'
import { ResponsiveLabel } from '../twoSizeLabel'
import { AveragesRow, DataRow, EventCell, GameLogTable, SeasonTableCon } from './styles'
import { Decimal1Digit } from '../../../../Utils'
import { Lk } from '../../../../Components/Links/Lk'
import { TableHeader } from '../../../../Components/Tables/TableHeader'

export const GameLogs: React.FC<React.PropsWithChildren> = () => {
  const { gameLogs, getGameLogs, seasonSelect } = useContext(PlayerProfileContext)!
  let [logs, setLogs] = useState<GameLogExt[]>([])
  let [logHeads, setLogHeads] = useState<{ name: string; longName: string }[]>([])

  useEffect(() => {
    let gameLogs = getGameLogs()
    setLogs(gameLogs)
    if (gameLogs.length > 0) {
      const head = gameLogs[0].values.map((v) => ({
        name: v.name,
        longName: v.longName,
      }))
      setLogHeads(head)
    }
  }, [gameLogs, seasonSelect])

  if (logs.length < 1) return null

  const getStatAvg = (stat: string) => {
    if (logs.length < 1) return '-'
    const total = logs.reduce((acc, log) => {
      const value = log.values.find((v) => v.field === stat)?.value
      let numVal = typeof value === 'string' ? parseFloat(value) : value
      return acc + (numVal || 0)
    }, 0)
    return Decimal1Digit(total / logs.length)
  }

  return (
    <SeasonTableCon>
      <GameLogTable>
        <thead className="headRow">
          <tr>
            <TableHeader ariaLabel="Game">Game</TableHeader>
            {logHeads.length > 0 &&
              logHeads.map((v, i) => (
                <TableHeader key={i} ariaLabel={v.longName}>
                  <ResponsiveLabel long={v.longName} short={v.name} switchOn={'sm'} />
                </TableHeader>
              ))}
          </tr>
        </thead>
        <tbody>
          {logs.length > 0 &&
            logs.map((row, idx) => (
              <DataRow key={idx}>
                <EventCell>
                  <Lk
                    link={row.eventUrl}
                    alt={`${row.event.month}/${row.event.day} vs ${row.event.teamName}`}
                  >
                    {row.event.month}/{row.event.day} vs {row.event.teamName}
                  </Lk>
                </EventCell>
                {row.values.map((v, i) => (
                  <td key={i}>{v.value}</td>
                ))}
              </DataRow>
            ))}
          {logs.length > 0 && (
            <AveragesRow>
              <td>Avg/gm</td>
              {logs[0].values.map((v, i) => (
                <td key={i}>{getStatAvg(v.field)}</td>
              ))}
            </AveragesRow>
          )}
        </tbody>
      </GameLogTable>
    </SeasonTableCon>
  )
}
